import React, { Fragment, Suspense, useEffect } from "react";
import Preloader from "../Components/common/Preloader";

const AboutComponent = React.lazy(() => import("../Components/About"));
const Breadcrumb = React.lazy(() => import("../Components/Breadcrumb"));
const Counter = React.lazy(() => import("../Components/Counter"));

const Skill = React.lazy(() => import("../Components/Skill"));
const Team = React.lazy(() => import("../Components/Team"));
const VideoArea = React.lazy(() => import("../Components/VideoArea"));
const Certifications = React.lazy(() => import("../Components/Certifications"));
const SearchPopup = React.lazy(() =>
  import("../Components/common/SearchPopup")
);

const About = () => {
  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById("cert");
      if (element && window.location.hash === "#cert") {
        element.scrollIntoView({ behavior: "smooth" });
      }
      const element1 = document.getElementById("intro");
      if (element1 && window.location.hash === "#intro") {
        element1.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // مقدار تاخیر به میل خودتان انتخاب کنید
  }, []);

  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Breadcrumb */}
          <Breadcrumb title={"درباره ما"} />

          {/* About  */}
          <div className="pd-top-120 pd-bottom-120">
            <AboutComponent />
          </div>

          {/* Counter  */}

          <div className="fact-area" style={{ background: "#f9f9f9" }}>
            <Counter />
          </div>

          {/* Skill  */}
          <Skill />

          {/* Video Area  */}
          <VideoArea />

          {/* Team  */}
          <div className="pd-bottom-80">
            <Team category="هیئت مدیره" />
          </div>
          <div className="pd-bottom-80">
            <Team category="مدیران ارشد" />
          </div>
          <div className="pd-bottom-80">
            <Team category="شعب و نمایندگی ها" />
          </div>

          <Certifications />
        </Suspense>
      </Fragment>
    </>
  );
};

export default About;
